import { useState, useRef, useEffect } from "react";
import { McInput } from "@maersk-global/mds-react-wrapper/components-core/mc-input";
import { McMenu } from "@maersk-global/mds-react-wrapper/components-core/mc-menu";
import { McList } from "@maersk-global/mds-react-wrapper/components-core/mc-list";
import { McListItem } from "@maersk-global/mds-react-wrapper/components-core/mc-list-item";
import { useStore } from "../../../store/store.context";
import { CHAT_CONSTANTS } from "../../../constants/constants";
import { McButton } from "@maersk-global/mds-react-wrapper";

import "./chat-input.scss";

const ChatInput = ({ searchQuery, setSearchQuery, onSend, disableSendBtn }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { updateStore } = useStore();
  const containerRef = useRef(null);

  // Close the menu when clicking outside the chat-input container
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setAnchorEl(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleCloseMenu = () => setAnchorEl(null);

  const handleSelectOption = (option) => {
    setSearchQuery(option);
    handleCloseMenu();
  };

  const onSendMessage = () => {
    onSend();
    handleCloseMenu();
  };

  const sendMessageOnEnter = (key) => {
    if (key === "Enter" && !disableSendBtn) {
      onSendMessage();
    }
  };

  const handleSamplePrompt = () => {
    // Don't hide the prompt panel when clicking on the input field
    // Only update promptQuery if needed
  };

  return (
    <div className="chat-input-container" ref={containerRef}>
      <McMenu
        trigger="click"
        zindex={99999}
        anchorEl={anchorEl}
        open={Boolean(anchorEl) && searchQuery?.trim() === ""}
        onClose={handleCloseMenu}
        className="chat-menu"
      >
        <McButton
          slot="trigger"
          variant="plain"
          appearance="neutral"
          style={{ width: "0px" }}
        ></McButton>
        <McList>
          {CHAT_CONSTANTS.PROMPT_CATEGORIES.flatMap(category =>
            category.prompts.map((prompt, index) => (
              <McListItem
                className="chat-menu-list"
                key={`${category.title}-${index}`}
                onClick={(e) => { e.stopPropagation(); handleSelectOption(prompt.query); }}
              >
                <span>{prompt.query}</span>
              </McListItem>
            ))
          )}
        </McList>
      </McMenu>

      <McInput
        label=""
        slot="trigger"
        placeholder="Type a question to search ..."
        value={searchQuery}
        icon="comment-dots"
        click={(event) => setAnchorEl(event.currentTarget)}
        trailingicon="navigation-arrow-up-right"
        clickabletrailingicon
        trailingiconclick={onSendMessage}
        input={(e) => setSearchQuery(e.target.value)}
        onKeyDown={(e) => sendMessageOnEnter(e.key)}
        className="chat-input-field"
      />
    </div>
  );
};

export default ChatInput;
